export default __webpack_public_path__ + "static/media/petfinder.59e9cec9.png";